import React, { useState } from "react";
import {
  ModalContainer,
  SelectedPlanInfo,
  PaymentOptions,
  PaymentAnswer,
  Row,
  Input,
  LightText,
  InputWrapper,
  EmptyDiv,
  Label,
  ModalLink,
} from "./RechargeModal.styles";
import { useSelector } from "react-redux";
import { ReactComponent as CloseSvg } from "../../assets/icons/close.svg";
import { ReactComponent as BtcSvg } from "../../assets/icons/btc.svg";
import { ReactComponent as TelegramSvg } from "../../assets/icons/telegramBlue.svg";
import { selectUser } from "../../store/slices/user/slice";
import Modal from "../utils/Modal/Modal";
import useScrollLock from "../../hooks/useScrollLock";
import Button from "../utils/Button/Button";

const RechargeModal = ({ isOpen, onClose, handleCardPayment }) => {
  const user = useSelector(selectUser);
  const [price, setPrice] = useState(10);

  useScrollLock(isOpen);

  if (!isOpen) return null;

  const actionCardPayment = (paymentMethod) => {
    handleCardPayment(paymentMethod, price);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalContainer>
        <Row>
          <SelectedPlanInfo>
            {user?.subscription?.name} Plan (Recharge)
          </SelectedPlanInfo>

          <CloseSvg onClick={onClose} style={{ cursor: "pointer" }} />
        </Row>

        <InputWrapper>
          <Label>Amount</Label>
          <Input
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
            value={price}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, ""); // uklanja sve što nije broj
              setPrice(value);
            }}
            placeholder="10"
            min={10}
          />
          {price ? (
            <LightText>
              You will receive {(user?.subscription?.topUpCredits / 10) * price}{" "}
              credits for ${price}
            </LightText>
          ) : (
            <EmptyDiv />
          )}
        </InputWrapper>

        <PaymentOptions>
          <PaymentAnswer>
            For Telegram star payment, we adhere to the principle of transparent
            pricing, and due tu high channel fees, the amount you pay may be
            higher the the price we offer.
          </PaymentAnswer>
          <PaymentAnswer>
            For crypto payments, we accept top-ups of any amount, but for
            top-ups less than $10, the actual credits you receive will be
            slightly less then expected due to the fees of the payment channel.
          </PaymentAnswer>
          <PaymentAnswer>
            If you don't see the credits, please contact us via{" "}
            <ModalLink
              onClick={() => {
                window.location.href = "mailto:support@playbox.vip";
              }}
            >
              email
            </ModalLink>
          </PaymentAnswer>

          <Button
            onClick={() => {
              actionCardPayment("TELEGRAM");
            }}
            title={"Card with Telegram"}
            rightIcon={<TelegramSvg />}
            style={{ width: "100%" }}
          />
          <Button
            onClick={() => {
              actionCardPayment("CRYPTO");
            }}
            title={"Pay with Crypto"}
            rightIcon={<BtcSvg />}
            style={{ width: "100%" }}
          />
        </PaymentOptions>
      </ModalContainer>
    </Modal>
  );
};

export default RechargeModal;
